import React from 'react'
import styled, { css } from 'styled-components'
import {
  useLocalLabels,
  useCookies,
  useProfile,
  useRequestAnon,
} from '@sentecacommerce-theme/lib'
import { ProfileLabels } from '../../profile.props'
import { Button, Loader, Typography } from '../../../Common'
import { TableItem } from './Components/TableItem'

export const GDPR = () => {
  const { gdpr } = useLocalLabels<ProfileLabels>()
  const { deleteCookies } = useCookies()
  const { data } = useProfile()
  const [requestAnonymization] = useRequestAnon()

  return (
    <div>
      {data?.anonymizationRequested ? (
        <AnonymizationRequest>
          {gdpr.awaitingAnonymizationApproval}
        </AnonymizationRequest>
      ) : (
        <>
          <Header>
            <Title>{gdpr?.title}</Title>
            <Content>{gdpr?.description}</Content>
          </Header>
          <Flex>
            {gdpr?.tables.map((item, index) => (
              <TableItem key={`TableItem__${index}`} {...item} />
            ))}
            <Item>
              <SubTitle>{gdpr?.actionTitle}</SubTitle>
            </Item>
            <ButtonsContainer>
              {gdpr?.actions?.map((action, index) => {
                return (
                  <>
                    {action.url === '#cookies' && (
                      <BtnContainer key={`Action__${index}`}>
                        <Button
                          variant="green"
                          bordered
                          label={action.label}
                          borderRadius="small"
                          onClick={() => deleteCookies()}
                        />
                      </BtnContainer>
                    )}

                    {action.url === '#request-anonymization' && (
                      <BtnContainer withMargin key={`Action__${index}`}>
                        <Button
                          variant="green"
                          bordered
                          label={action.label}
                          borderRadius="small"
                          onClick={() => {
                            requestAnonymization()
                          }}
                        />
                      </BtnContainer>
                    )}
                  </>
                )
              })}
            </ButtonsContainer>
          </Flex>
        </>
      )}
    </div>
  )
}

const Title = styled(Typography).attrs({
  className: 'mb-4',
  as: 'h3',
  variant: 2,
  color: 'greyTitle',
})<any>`
  font-weight: 400;
`

const SubTitle = styled(Typography).attrs({
  as: 'h4',
  variant: 5,
  color: 'greyTitle',
  className: 'mb-3 pb-2',
})<any>`
  font-weight: 400;
  border-bottom: 1px solid ${({ theme }) => theme.palette.disabled};
`

const Header = styled.div.attrs({
  className: 'mb-4',
})``

const AnonymizationRequest = styled.div`
  font-weight: bold;
`

const Content = styled(Typography).attrs({
  as: 'p',
  variant: 6,
})`
  line-height: 1.4;
`

const Flex = styled.div.attrs({
  className: 'row gy-4 gx-4',
})``

const Item = styled.div.attrs({
  className: 'col-12',
})``

const BtnContainer = styled.div.attrs({
  className: 'd-flex',
})<{ withMargin?: boolean }>`
  width: 100%;
  height: 100%;

  & > a,
  span,
  button {
    font-size: 1.3rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    & > a {
      padding-top: 1rem;
    }
    ${(props) =>
      props.withMargin &&
      css`
        margin-left: 1.8rem;
      `}
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md.max}) {
    & > a,
    button {
      width: 100%;
      padding: 1rem 0;
      padding-top: 1.2rem;
      font-size: 1.05rem;
    }
  }
`

const ButtonsContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  flex-direction: column;
  ${BtnContainer} + ${BtnContainer} {
    margin-top: 2rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md.max}) {
    flex-direction: row;
    justify-content: center;
    ${BtnContainer} + ${BtnContainer} {
      margin-top: 0;
    }
  }
`
